import React from 'react';
import classnames from 'classnames';
import { ConfigProvider, Layout } from 'tea-component';
import '@/pages/opinion/assets/scss/index.scss';
import { getLocale, useLocation } from 'umi';
import { getTeaLocale } from '@/pages/home/utils/lang';
import LeftMenu from './LeftMenu';
import { DBOM_POINT } from '@opm/operationLog/buriedPoint';
import { isMarketingRouteMatched } from '../_config/utils';
import NotFound from '../pages/NotFound/index';
import { useEmbeddedPageOptions } from '@home/hooks/useEmbeddedPageOptions';
import "./index.scss";
const { Body, Content } = Layout;

export function hideSidebarByPage() {
  const whites = ['/marketing/Download'];
  return whites.some((item) => location.pathname.includes(item));
}

DBOM_POINT.init();

// eslint-disable-next-line react/display-name
export default (props: any) => {
  const locale = getTeaLocale(getLocale());
  const location = useLocation();
  const embedOptions = useEmbeddedPageOptions();

  return (
    <ConfigProvider locale={locale}>
      <Body
        className={classnames('layout__body', {
          'dbh-embed-hide-page-header': embedOptions.hidePageHeader,
          'dbh-embed-hide-page-tabs': embedOptions.hidePageTabs,
        })}
      >
        {!embedOptions.hideLeftMenu && !hideSidebarByPage() && <LeftMenu />}
        <Content className="dbo-body">
          {!isMarketingRouteMatched(location.pathname) ? <NotFound /> : props.children}
        </Content>
      </Body>
    </ConfigProvider>
  );
};
